import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import MarketingAI from "@/pages/admin/MarketingAI";

export const Route = createFileRoute("/admin/marketing-ai")({
  head: () => pageHead("Admin \u2014 Marketing Ai \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: MarketingAI,
});
